import { apiClient } from '@/api/client';
import {
  UserEventCreateDTOEntityType,
  UserEventCreateDTOEventType,
  UserEventCreateDTOSource,
} from '@/api/models';
import { useMutation } from '@tanstack/react-query';

export interface TrackEventData {
  eventType: UserEventCreateDTOEventType;
  entityType?: UserEventCreateDTOEntityType;
  entityId?: number;
  properties?: Record<string, string | number | boolean>;
}

export const useTrackEvent = () => {
  return useMutation({
    mutationFn: async (eventData: TrackEventData) => {
      return apiClient.POST('/user-events', {
        body: {
          ...eventData,
          source: UserEventCreateDTOSource.admin,
        },
      });
    },
    onError: error => {
      console.error('Failed to track event:', error);
    },
  });
};

export const useTrackEventSimple = () => {
  const trackEventMutation = useTrackEvent();

  const trackEvent = (eventData: TrackEventData) => {
    trackEventMutation.mutate(eventData);
  };

  return { trackEvent };
};
